export const getDomesticInsurance = state => state.domesticInsurance;
